import {
  parseFilterArrayFromQuery,
  parseSearchFromQuery,
  parseTableOptionsFromQuery,
} from '@/utils/listRouteState'

/**
 * Query params for GET job detail when list_navigation=1 — mirrors getAllJobs / OfferViewList.
 */
export function buildJobDetailNavigationParams(routeQuery) {
  const defaults = {
    sortDesc: [true],
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
  }
  const options = parseTableOptionsFromQuery(routeQuery, defaults)
  const ordering = options.sortBy.map((el, index) => {
    const parsedEl = el
      .replaceAll('.', '__')
      .replace('candidatesAmount', 'candidates_amount')
      .replace('workflowTitle', 'workflow__title')

    return `${options.sortDesc[index] ? '-' : ''}${parsedEl}`
  })

  return {
    list_navigation: '1',
    stage: parseFilterArrayFromQuery(routeQuery, 'stage'),
    assigned_to: parseFilterArrayFromQuery(routeQuery, 'assignedTo'),
    city: parseFilterArrayFromQuery(routeQuery, 'city'),
    workflow__title: parseFilterArrayFromQuery(routeQuery, 'workflow'),
    search: parseSearchFromQuery(routeQuery),
    ordering,
  }
}
